import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'

export default class HomePage extends Component {
  render() {
    return (
      <Container>
        <Helmet>
          <meta charSet="utf-8" />
          <script src="js/noise.min.js" />
          <script src="js/util.js" />
          <script src="js/swirl.js" />
        </Helmet>
        <Home>
          <h3>Bnt Design</h3>
          <h2>小型组件库</h2>
          <p data-testid="homeDescription">
            服务于小打小闹级产品的设计体系，基于确定和自然的设计价值观上的模块化解决方案，让设计者和开发者专注于更好的用户体验。
          </p>
          <Copyright data-testid="copyright">
            Copyright © 2019 NetDragon Websoft Inc. All Rights Reserved
          </Copyright>
        </Home>
      </Container>
    )
  }
}

const Container = styled.div.attrs({
  className: 'content content--canvas',
})`
  display: flex;
  flex-direction: column;
`
const Home = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 64px);
  color: white;
  z-index: 100;

  h2 {
    font-size: 58px;
    margin: 8px 0;
  }
  h3 {
    font-size: 40px;
    color: lightgray;
    margin: 0;
  }
  p {
  p {
    padding: 0 20px;
  }
`
const Copyright = styled.div`
  position: fixed;
  bottom: 0;
  margin-bottom: 12px;
`
